
import api from "../Token";


export const extract = async (files) => {
  try {
    const formData = new FormData();

    files.forEach((file) => {
      formData.append("files[]", file);
    });

    const { data } = await api.post("/extract", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return data;
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        status: error.response.status,
        ...error.response.data,
      };
    }

    if (error.request) {
      return {
        success: false,
        status: 0,
        message: "Não foi possível comunicar com o servidor.",
      };
    }

    return {
      success: false,
      status: 0,
      message: error.message || "Erro inesperado.",
    };
  }
};